import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { getTrellisButtonVariantProps } from 'pricing-pages-ui-components/utils/buttonVariantUtils';
import { TalkToSalesFallback } from '../../../features/purchaseMotions/components/TalkToSalesFallback';
import { ErrorBoundary } from '../../../v2/components/error-boundary/ErrorBoundary';
import { SUITE_FEATURE_TABLE_HEADER } from '../../../v2/constants/tracking/TrackingSources';
import { FreeToolsPurchaseMotion } from '../../../v2/containers/FreeToolsPurchaseMotion';
import { useIsInAppAuth } from '../../../v2/hooks/user/useUserInfo';
import FeatureTableColTag from '../FeatureTableColTag';
import FeatureTableFreePriceDisplay from '../FeatureTableFreePriceDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FreeProductFeatureTableHeaderCell = ({
  apiName,
  badgeName,
  screen,
  trackingSource,
  sourceId = SUITE_FEATURE_TABLE_HEADER
}) => {
  const isInApp = useIsInAppAuth();
  const trellisCtaVariantProps = getTrellisButtonVariantProps({
    variant: 'table-header'
  });
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    paddingInline: "0",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(FeatureTableColTag, {
      apiName: apiName,
      badgeName: badgeName
    }), /*#__PURE__*/_jsx(View, {
      maxInlineSize: "13ch",
      children: /*#__PURE__*/_jsx(Text, {
        as: "strong",
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "products.hubspot-free"
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlock: "100",
      as: "div",
      children: /*#__PURE__*/_jsx(FeatureTableFreePriceDisplay, {})
    }), /*#__PURE__*/_jsx(View, Object.assign({}, trellisCtaVariantProps, {
      children: /*#__PURE__*/_jsx(ErrorBoundary, {
        fallback: /*#__PURE__*/_jsx(TalkToSalesFallback, {
          apiName: apiName,
          trackingSource: trackingSource,
          screen: screen
        }),
        children: /*#__PURE__*/_jsx(FreeToolsPurchaseMotion, {
          trackingSource: trackingSource,
          sourceId: sourceId,
          productLine: "crm",
          isInApp: isInApp
        })
      })
    }))]
  });
};
export default FreeProductFeatureTableHeaderCell;